const QUESTION_TYPES = {
	CREATE: 'QUESTIONS/CREATE',
	UPDATE: 'QUESTIONS/UPDATE',
	REMOVE: 'QUESTIONS/REMOVE',
};

export default QUESTION_TYPES;
